import styled from 'styled-components'
import Projetos from '../../components/Projetos'
import { Container } from '../../styles'

export const ListaProjetos = styled(Projetos)``
export const ContainerLista = styled(Container)`
  grid-template-columns: auto;
`
